import React, { useEffect, useReducer, useState, useRef } from "react";
import {
  ModelViewer,
  ARView,
  logo,
  convert,
  TbAugmentedReality,
  TbView360Number,
  ToastContainer,
  toast,
  FaCartFlatbed,
  GrPowerReset,
  MdAddCircleOutline,
  baseTypeOptions,
  conditionalOptions,
  actualHeights,
  levelUrls,
  initialState,
  heroReducer,
  addLevel,
  toggleView,
  resetAll,
  removeLevel,
  handleBaseTypeChange,
  addToCart,
} from "./index";
import Footer from "../Footer";
import { useLocation, useParams } from "react-router-dom";
import { FaLayerGroup } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import { FaRuler } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "@google/model-viewer";
import ImageCarousel from "./ImageCarousel";
import { hideARGestureGuideKey } from "./constants";
const Hero3D = () => {
  const scrollToTopRef = useRef(null); // ✅ Define the ref
  const scrollToARRef = useRef(null);
  const { id } = useParams();
  const [state, dispatch] = useReducer(heroReducer, initialState);
  const [cart, setCart] = useState(null);
  const [arLoading, setArLoading] = useState(false);
  const [variant_ID, setVariantID] = useState(null);
  const [IdNull, setIdNull] = useState(false);
  const [showARGestureGuide, setShowARGestureGuide] = useState(false);
  const [mesh, setMesh] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const hideARGestureGuide = localStorage.getItem(hideARGestureGuideKey);
  const modelViewerRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [state.activeView]);

  useEffect(() => {
    const endpoint = "https://duralifthardware.com/api/2024-10/graphql.json";
    const storefrontAccessToken = process.env.REACT_APP_API_KEY;

    const createCartQuery = `mutation { cartCreate { cart { id checkoutUrl } userErrors { field message } } }`;

    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
      },
      body: JSON.stringify({ query: createCartQuery }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.data?.cartCreate?.cart) {
          setCart(result.data.cartCreate.cart);
        } else {
          console.error(
            "Cart creation failed:",
            result.data?.cartCreate?.userErrors || result.errors
          );
        }
      })
      .catch((error) => console.error("Error creating cart:", error));
  }, []);

  useEffect(() => {
    const baseTypeFromId = baseTypeOptions.find(
      (option) => option.id === parseInt(id)
    );
    if (baseTypeFromId) {
      dispatch({ type: "SET_BASE_TYPE", payload: baseTypeFromId.value });
      handleBaseTypeChange(
        baseTypeFromId.value,
        state.levels,
        levelUrls,
        actualHeights,
        state.scale,
        dispatch,
        toast,
        state.cumulativeHeight,
        state.rotation
      );
      setVariantID(baseTypeFromId.varaintID);
      const item = {
        variantID: baseTypeFromId.varaintID,
        quantity: 1,
        description: { base: baseTypeFromId.value },
      };
      const updatedLineItems = [...state.lineItem, item];
      dispatch({ type: "SET_LINEITEM", payload: updatedLineItems });
    } else {
      setIdNull(true);
    }
  }, [id]);

  const handleTypeChange = (e) =>
    dispatch({ type: "SET_SELECTED_TYPE", payload: e.target.value });

  const handleBaseTypeChange1 = (e) => {
    dispatch({ type: "SET_BASE_TYPE", payload: e.target.value });
    const baseTypeFromId = baseTypeOptions.find(
      (option) => option.value === e.target.value
    );
    handleBaseTypeChange(
      baseTypeFromId.value,
      state.levels,
      levelUrls,
      actualHeights,
      state.scale,
      dispatch,
      toast,
      state.cumulativeHeight,
      state.rotation
    );
    setVariantID(baseTypeFromId.varaintID);
    const item = {
      variantID: baseTypeFromId.varaintID,
      quantity: 1,
      description: { base: baseTypeFromId.value },
    };
    const updatedLineItems = [...state.lineItem, item];
    dispatch({ type: "SET_LINEITEM", payload: updatedLineItems });
  };

  const handleLengthChange = (e) => {
    const selectedLengthValue = parseInt(e.target.value);
    if (state.levels.length === 0 && selectedLengthValue !== 24) {
      toast.error("The first level must have a length of 24 inches.");
    } else {
      dispatch({ type: "SET_SELECTED_LENGTH", payload: selectedLengthValue });
    }
  };

  const addTOCart = () => {
    variant_ID === null
      ? toast.error("Please select a base type to start.")
      : addToCart(
          cart,
          state,
          variant_ID,
          toast,
          dispatch,
          setCart,
          state.descripation
        );
  };

  /**
   * Handles the "View in AR" button click.
   *
   * - Validates required selections and model loading state.
   * - Detects the user's platform (iOS, Android, or compatible Mac).
   * - If on a supported mobile platform:
   *    - Creates a <model-viewer> element with AR capabilities.
   *    - Configures AR settings such as scale, camera behavior, and AR modes.
   *    - Triggers the device's native AR viewer (Scene Viewer on Android or Quick Look on iOS).
   * - If not on a supported mobile platform:
   *    - Shows a fallback 3D preview instead of AR mode.
   * - Displays toast notifications for invalid states or unsupported platforms.
   */

  const showARView = async () => {
    // Validate preconditions
    if (!validatePreconditions()) return;

    // Prepare for AR view
    setMesh(false);

    // Handle AR view based on device type
    if (isMobileDevice()) {
      await showMobileARView();
    } else {
      showDesktopFallback();
    }
  };

  const handleARViewClick = () => {
    if (!validatePreconditions()) return;

    if (hideARGestureGuide) {
      showARView();
    } else {
      setShowARGestureGuide(true);
    }
  };

  const validatePreconditions = () => {
    if (state.baseType === "") {
      toast.error("Please select a base type to start.");
      return false;
    }

    if (
      state.model === null ||
      state.modelIos === null ||
      state.performingExport
    ) {
      toast.error("Model is loading. Please wait...");
      return false;
    }

    return true;
  };

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent;
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isMacDesktop =
      /Macintosh|Mac/i.test(userAgent) && !("ontouchend" in document);

    return isAndroid || isIOS || isMacDesktop;
  };

  const showMobileARView = async () => {
    try {
      const modelUrl =
        typeof state.model === "string"
          ? state.model
          : URL.createObjectURL(state.model);

      if (modelViewerRef.current) {
        modelViewerRef.current.remove();
      }

      modelViewerRef.current = createModelViewer(modelUrl);
      document.body.appendChild(modelViewerRef.current);

      // Small delay to ensure viewer is ready
      setArLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 500));
      await modelViewerRef.current.activateAR?.();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("Failed to launch AR view:", error);
      toast.error("Failed to launch AR experience. Please try again.");
    } finally {
      setArLoading(false);
    }
  };

  const createModelViewer = (modelUrl) => {
    const viewer = document.createElement("model-viewer");
    viewer.style.display = "none";

    // Model source
    viewer.setAttribute("src", modelUrl);

    // AR Configuration
    const arAttributes = {
      ar: "true",
      "ar-modes": "webxr scene-viewer quick-look",
      "ar-scale": "fixed",
      "ar-placement": "floor",
      "quick-look-browsing": "true",
      "shadow-intensity": "1",
      exposure: "1",
    };

    // Viewer behavior
    const viewerAttributes = {
      scale: "1 1 1",
      "camera-controls": "false",
      "disable-zoom": "true",
    };

    // Set all attributes
    Object.entries({ ...arAttributes, ...viewerAttributes }).forEach(
      ([key, value]) => {
        viewer.setAttribute(key, value);
      }
    );

    // Remove unwanted attributes
    ["camera-orbit", "auto-rotate"].forEach((attr) => {
      viewer.removeAttribute(attr);
    });

    return viewer;
  };

  const showDesktopFallback = () => {
    toast.info("AR is not available on desktop. Showing 3D preview.");
    const container = document.getElementById("model-viewer-container");
    if (container) {
      container.style.display = "block";
    }
  };

  return (
    <div className="flex flex-col h-full 2xl:h-auto bg-gray-200 relative">
      <div id="model-viewer-container" style={{ display: "none" }}></div>
      {/* Loading Overlay */}
      {state.isLoading && (
        <div className="absoxlute inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
          <div className="text-white flex items-center gap-2">
            <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-white" />
          </div>
        </div>
      )}

      <div
        className="flex flex-col md:flex-row w-full flex-grow h-full lg:mb-3 overflow-hidden"
        ref={scrollToTopRef}
      >
        <div className="w-full md:w-80 lg:w-96 p-4 md:p-6 bg-gray-200 shadow-2xl rounded-3xl flex-shrink-0">
          <div className="flex justify-center mb-4 lg:mb-2">
            <img
              src={logo}
              alt="Logo"
              className="w-24 md:w-36 h-auto transition-transform transform hover:scale-105"
            />
          </div>
          <div>
            {/* AR/VR Button Section */}
            <div className="flex justify-center mb-2">
              <div
                className="flex rounded-full md:mx-3 justify-center items-center p-1 shadow-inner bg-gray-100"
                style={{
                  boxShadow: "inset 0px 4px 8px rgba(0, 0, 0, 0.15)",
                }}
              >
                <button
                  onClick={handleARViewClick}
                  className={`px-4 py-3 rounded-full whitespace-nowrap transition duration-300 md:text-sm lg:text-lg ${
                    state.activeView === "AR"
                      ? "bg-gray-700 text-white"
                      : "bg-gray-300 text-gray-700"
                  }`}
                  style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  }}
                  disabled={arLoading}
                >
                  <div className="flex items-center gap-2">
                    <TbAugmentedReality
                      className={arLoading ? "animate-spin" : ""}
                      size={24}
                    />{" "}
                    <span>View in Room</span>
                  </div>
                </button>
                <button
                  onClick={() => {
                    setMesh(!mesh);
                    toggleView("VR", dispatch);
                  }}
                  className={`px-4 py-3 rounded-full whitespace-nowrap transition duration-300 md:text-sm lg:text-lg ${
                    state.activeView === "VR"
                      ? "bg-gray-700 text-white"
                      : "bg-gray-300 text-gray-700"
                  }`}
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <div className="flex items-center gap-2">
                    <TbView360Number size={24} />
                    <span>View in VR</span>
                  </div>
                </button>
              </div>
            </div>

            {/* Configurator Title */}
            <h2 className="text-2xl md:text-2xl mb-4 lg:left-10 relative text-gray-900 text-center md:text-left font-semibold">
              Model Configurator
            </h2>

            <div className="flex flex-col space-y-4 xl:space-y-2">
              <div className="flex justify-end mt-4 gap-3">
                {/* Add to Cart and Reset Buttons */}
                <button
                  onClick={() => addTOCart()}
                  className="bg-green-500 text-white px-4 py-2 flex items-center text-sm rounded-full shadow-md hover:bg-green-600 hover:shadow-lg transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition duration-300"
                  disabled={state.isLoading || state.isInCart}
                >
                  <FaCartFlatbed size={20} className="mr-2" />
                  {state.isInCart ? "Added to Cart" : "Add to Cart"}
                </button>

                <button
                  onClick={() =>
                    resetAll(state, dispatch, toast, setVariantID, setIdNull)
                  }
                  className="bg-yellow-500 text-white px-3 py-2 flex items-center text-sm rounded-full shadow-md hover:bg-yellow-600 hover:shadow-lg transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 transition duration-300"
                >
                  <GrPowerReset size={20} className="mr-2" />
                  Reset
                </button>
              </div>

              {/* Select Inputs */}
              <div className="space-y-6">
                <div className="relative">
                  <label className="block text-gray-700 text-sm font-medium mb-2">
                    Select Platform Type:
                  </label>
                  <div className="relative">
                    {IdNull ? (
                      <select
                        value={state.baseType}
                        onChange={handleBaseTypeChange1}
                        className="block w-full p-2 pl-10 bg-white border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                        disabled={state.baseType}
                        placeholder="Select Base Type"
                      >
                        <option value="" disabled>
                          Select Base Type
                        </option>
                        {baseTypeOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        value={state.baseType}
                        className="block w-full p-2 pl-10 bg-gray-100 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                        disabled
                        placeholder={state.baseType}
                      />
                    )}
                    <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
                      <FaLayerGroup size={20} />
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <label className="block text-gray-700 text-sm font-medium mb-2">
                    Select Number of Platforms:
                  </label>
                  <div className="relative">
                    <select
                      value={state.selectedType}
                      onChange={handleTypeChange}
                      className="block w-full p-2 pl-10 bg-white border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                      disabled={!state.baseType}
                    >
                      <option value="">Select Platform</option>
                      {state.baseType &&
                        conditionalOptions[state.baseType].map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </select>
                    <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
                      <FaLayerGroup size={20} />
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <label className="block text-gray-700 text-sm font-medium mb-2">
                    Select Length (in inches):
                  </label>
                  <div className="relative">
                    <select
                      value={state.selectedLength}
                      onChange={handleLengthChange}
                      className="block w-full p-2 pl-10 bg-white border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                      disabled={!state.baseType}
                    >
                      <option value={6}>6</option>
                      <option value={12}>12</option>
                      <option value={24}>24</option>
                    </select>
                    <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
                      <FaRuler size={20} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Buttons for Adding/Removing Levels */}
            <div className="flex flex-wrap justify-evenly md:justify-start lg:justify-evenly space-x-4 mt-4">
              <button
                onClick={() => addLevel(state, dispatch, toast)}
                className="bg-blue-500 text-white px-3 py-2 flex items-center text-sm rounded-full shadow-md hover:bg-blue-600 hover:shadow-lg transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-300"
              >
                <MdAddCircleOutline size={20} className="mr-2" />
                Add Level
              </button>
              <button
                onClick={() =>
                  removeLevel(state, dispatch, toast, setVariantID, setIdNull)
                }
                className="bg-red-500 text-white ml-4 px-4 py-2 flex items-center text-sm rounded-full shadow-md hover:bg-red-600 hover:shadow-lg transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition duration-300"
              >
                <MdOutlineCancel size={20} className="mr-2" />
                Remove
              </button>
            </div>
          </div>
        </div>
        <div className="w-full h-full" ref={scrollToARRef}>
          {state.activeView === "VR" ? (
            <div className="flex-1 p-2 md:p-3 flex w-full items-center justify-center h-full shadow-inner rounded-3xl">
              <ModelViewer
                scale={state.scale}
                levels={state.levels}
                dispatch={dispatch}
                psingleCount={state.pSingle}
                levelIndex={state.levelIndex}
                platformName={state.platformName}
                scrollToTopRef={scrollToTopRef}
                selectedPart={state.selectedPart}
                isMesh={mesh}
                setMesh={setMesh}
                performingExport={state.performingExport}
              />
            </div>
          ) : state.activeView === "AR" ? (
            <div className="flex-1 p-4 md:p-6 flex items-center justify-center h-full bg-white shadow-inner rounded-3xl">
              <ARView model={state.model} />
            </div>
          ) : (
            <div className="flex-1 p-4 md:p-6 flex items-center justify-center h-full bg-white shadow-inner rounded-3xl">
              <p className="text-red-700">Select a view to start.</p>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
      <Footer className="block bg-gray-800 text-white p-4" />

      {showARGestureGuide && (
        <ImageCarousel
          rotateInterval={3000}
          onClose={() => setShowARGestureGuide(false)}
          showARView={showARView}
        />
      )}
    </div>
  );
};

export default Hero3D;
